module.exports = __webpack_public_path__ + "img/kaiqutitle.159ebe24.png";